export default __webpack_public_path__ + "static/media/docs.4344216e.svg";